import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TitleService } from 'app/shared/services/title/title.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(
    private router: Router,
    private titleService: TitleService
  ) { }

  ngOnInit(): void {
    this.titleService.title.next('Not found');
    this.redirection();
  }

  private redirection(): void {
    setTimeout(() => {
      this.router.navigate(['home']);
    }, 2500);
  }

}
